export default function Hamburger({ darkMode }) {
    const bgClass = darkMode ? 'bg-bluekali-black' : 'bg-bluekali-white'

    return (
        <div className="flex flex-col justify-between h-4 w-6 mr-6 md:hidden transform translate-y-[9px]">
            <div className={`h-[2px] w-full ${bgClass} rounded-full transition-all duration-300`}/>
            <div className={`h-[2px] w-full ${bgClass} rounded-full transition-all duration-300`}/>
            <div className={`h-[2px] w-full ${bgClass} rounded-full transition-all duration-300`}/>
        </div>
    );
}
